<template>
    <div class="wrapper" :class="tabClass">
        <header>
            <h2 class="new-headline-md text-centered text-bold">{{ headline }}</h2>

            <p v-if="text" class="new-text-xl text-centered text-color-default">{{ text }}</p>
        </header>

        <slot></slot>

        <div class="form-input-radio-button-wrapper">
            <form-input-type-radio-button
                v-for="option in options"
                :key="option.label"
                :value="option.label"
                :icon="icons[option.icon] || null"
                :danger="option.danger === true"
                @onClick="choose(option.value)"
            ></form-input-type-radio-button>
        </div>

        <slot name="footer"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            tabClass: {
                type: String,
                required: true
            },

            headline: {
                type: String,
                required: true
            },

            text: {
                type: String,
                required: false,
                default: null
            },

            options: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                icons: {
                    yes: '<span class="material-symbols-rounded choice-icon choice-icon--yes">done</span>',
                    no: '<span class="material-symbols-rounded choice-icon choice-icon--no">close</span>',
                    unsure: '<span class="material-symbols-rounded choice-icon choice-icon--unsure">question_mark</span>'
                }
            }
        },

        methods: {
            choose(value) {
                setTimeout(() => {
                    this.$emit('answer', value)
                }, 250)
            }
        }
    }
</script>
